import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Typography } from '@mui/material';
import { ScreenFrame, ConfirmDialog } from '../PrototypeShared';

export default function TraceTestScreen() {
  const [generateModal, setGenerateModal] = useState(false);

  return (
    <ScreenFrame
      title="Trace test (auto-generate)"
      actions={<Button component={Link} to="/prototype/audits" variant="outlined" size="small">Audits</Button>}
    >
      <Typography color="text.secondary" paragraph>Generate trace test from pallet/retailer. Link to audit.</Typography>
      <Button variant="contained" onClick={() => setGenerateModal(true)}>Generate trace test</Button>
      <ConfirmDialog open={generateModal} title="Trace test generated" message="Trace test created and linked to selected audit." onConfirm={() => setGenerateModal(false)} onCancel={() => setGenerateModal(false)} confirmLabel="OK" />
    </ScreenFrame>
  );
}
